import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AppMainComponent } from 'src/app/app.main.component';
import { BaseComponent } from 'src/app/base/base-component';
import { Emplacement } from 'src/app/entites/emplacement';
import { EmployeEntite } from 'src/app/entites/employe';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { RapportSstService } from 'src/app/services/rapport-sst-service';

@Component({
  selector: 'app-ajouter-rapport-journalier-sst',
  templateUrl: './ajouter-rapport-journalier-sst.component.html'
})
export class AjouterRapportJournalierSstComponent extends BaseComponent {

  employe: EmployeEntite = this.profilService.ProfilCourant();
  emplacements: Emplacement[] = this.sdb.Emplacements().filter(e => e.codeProjet);
  emplacement: Emplacement = this.sdb.Emplacements().find(e => e.membreEmplacements.find(m => m.employeId == this.employe.employeId));
  date: Date = new Date();
  copierValeurs: boolean = true;

  loading: boolean = false;

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute,
    public router: Router,
    public messageService: MessageService,
    public appMain: AppMainComponent,
    public ref: DynamicDialogRef,
    public rapportSstService: RapportSstService
  ) {
    super(sdb, profilService, route, router, appMain);

    this.router.events.subscribe((event) => {
      if (event.constructor.name === "NavigationEnd") {
        this.ref?.close();
      }
    });
  }

  creerRapport() {
    this.loading = true;
    this.rapportSstService.Ajouter({
      rapportSstId: 0,
      date: this.date,
      emplacementId: this.emplacement.emplacementId,
      employeId: this.employe.employeId,
      statutId: 1,
      ligneRapportSst: []
    }, this.copierValeurs).subscribe({
      next: (x) => {
        this.router.navigate(['/assurancequalite/rapportjournalier', x.rapportSstId]);
        this.ref.close();
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport créé avec succès' });
      },
      error: (error) => {
        if (error.status === 409) {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error,
            key: 'already-exists',
            data: {
              rapportSstId: error.error
            }
          })
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error })
        } 
        this.loading = false;
      }
    });
  }
}